module.exports = __webpack_public_path__ + "media/audio5.fc75c18b.mp3";